module.exports = __webpack_public_path__ + "static/img/87.7778cf2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/87.png
// module id = bvKv
// module chunks = 1